import { moduleFactory } from "@/factories/module";
import { modNumber } from "@/modules/number/modulo";

export const numberModule = moduleFactory.create({
  mod: modNumber,
});
